(ns yardwerkz.web.domain.service
  "Pure functions for service-related business logic.
   Copied from frontend/src/yardwerkz/domain/service.cljs — zero RN deps.")

;; =============================================================================
;; Service Icon/Color Configuration
;; =============================================================================

(def category-styles
  {"lawn-care" {:icon "grass"
                :bg-color :green-100
                :text-color :green-700}
   "landscaping" {:icon "tree"
                  :bg-color :green-200
                  :text-color :green-800}
   "cleanup" {:icon "leaf"
              :bg-color :orange-100
              :text-color :orange-700}
   "maintenance" {:icon "sprout"
                  :bg-color :green-100
                  :text-color :green-700}
   "seasonal" {:icon "snowflake"
               :bg-color :blue-100
               :text-color :blue-700}
   "tree-care" {:icon "pine-tree"
                :bg-color :green-200
                :text-color :green-800}
   "cleaning" {:icon "water"
               :bg-color :blue-100
               :text-color :blue-700}})

(def name-icon-overrides
  {"Lawn Mowing" "grass"
   "Hedge Trimming" "tree"
   "Leaf Removal" "leaf"
   "Weed Removal" "sprout"
   "Snow Removal" "snowflake"
   "Garden Bed Maintenance" "flower-tulip"
   "Tree Pruning" "pine-tree"
   "Pressure Washing" "water"
   "Fertilization" "bottle-tonic-plus"
   "Aeration" "dots-grid"})

(def default-style
  {:icon "tools"
   :bg-color :gray-100
   :text-color :gray-700})

(defn- normalize-category [category]
  (cond
    (and (map? category) (:db/ident category))
    (name (:db/ident category))
    (keyword? category) (name category)
    (string? category) category
    :else nil))

(defn enrich-service [service]
  (let [raw-category (or (:category service) (:service/category service))
        category (normalize-category raw-category)
        service-name (or (:name service) (:service/name service))
        service-key (or (:service/key service) (:key service))
        description (or (:description service) (:service/description service))
        base-style (get category-styles category default-style)
        icon-override (get name-icon-overrides service-name)]
    (cond-> (merge service base-style)
      icon-override (assoc :icon icon-override)
      service-key (assoc :id (name service-key) :key service-key)
      service-name (assoc :name service-name)
      category (assoc :category category)
      description (assoc :description description))))

(defn enrich-services [services]
  (mapv enrich-service services))

(defn valid-service? [service]
  (and (some? service) (some? (:id service))))

(defn service-selected? [selected service]
  (and (some? selected) (= (:id selected) (:id service))))
